// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dsr-modal {
    position: fixed;
    inset: 0;
    z-index: 220;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(6px);
}

.dsr-modal__card {
    width: 100%;
    max-width: 480px;
    padding: 24px 22px 22px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: linear-gradient(168deg, rgba(48, 48, 52, 0.98) 0%, rgba(24, 24, 28, 0.99) 100%);
    box-shadow: 0 24px 56px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.dsr-modal__card h2 {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 600;
    color: #f2f2f2;
}

.dsr-timeline {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    margin: 0;
    list-style: none;
}

.dsr-timeline__item {
    display: flex;
    gap: 14px;
    padding: 12px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.dsr-timeline__item:last-child {
    border-bottom: none;
}

.dsr-timeline__dot {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    margin-top: 6px;
    border-radius: 50%;
    background: rgba(192, 159, 83, 0.7);
}

.dsr-timeline__action {
    font-size: 0.875rem;
    color: #e0e0e0;
    line-height: 1.4;
}

.dsr-timeline__time {
    display: block;
    margin-top: 2px;
    font-size: 0.75rem;
    color: rgba(150, 150, 150, 0.8);
}

.dsr-meta-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 14px;
}

.dsr-meta-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.dsr-meta-label {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(192, 159, 83, 0.9);
}

.dsr-meta-value {
    font-size: 0.875rem;
    color: #e4e4e4;
    line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/DSR/Style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,2FAA2F;IAC3F,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".dsr-modal {\n    position: fixed;\n    inset: 0;\n    z-index: 220;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    background: rgba(0, 0, 0, 0.65);\n    backdrop-filter: blur(6px);\n}\n\n.dsr-modal__card {\n    width: 100%;\n    max-width: 480px;\n    padding: 24px 22px 22px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    background: linear-gradient(168deg, rgba(48, 48, 52, 0.98) 0%, rgba(24, 24, 28, 0.99) 100%);\n    box-shadow: 0 24px 56px rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.dsr-modal__card h2 {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: #f2f2f2;\n}\n\n.dsr-timeline {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.dsr-timeline__item {\n    display: flex;\n    gap: 14px;\n    padding: 12px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.dsr-timeline__item:last-child {\n    border-bottom: none;\n}\n\n.dsr-timeline__dot {\n    flex-shrink: 0;\n    width: 8px;\n    height: 8px;\n    margin-top: 6px;\n    border-radius: 50%;\n    background: rgba(192, 159, 83, 0.7);\n}\n\n.dsr-timeline__action {\n    font-size: 0.875rem;\n    color: #e0e0e0;\n    line-height: 1.4;\n}\n\n.dsr-timeline__time {\n    display: block;\n    margin-top: 2px;\n    font-size: 0.75rem;\n    color: rgba(150, 150, 150, 0.8);\n}\n\n.dsr-meta-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 14px;\n}\n\n.dsr-meta-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.dsr-meta-label {\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: rgba(192, 159, 83, 0.9);\n}\n\n.dsr-meta-value {\n    font-size: 0.875rem;\n    color: #e4e4e4;\n    line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
